import { render } from "./Episode.vue?vue&type=template&id=5754853a&scoped=true"
import script from "./Episode.vue?vue&type=script&lang=js"
export * from "./Episode.vue?vue&type=script&lang=js"

import "./Episode.vue?vue&type=style&index=0&id=5754853a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5754853a"]])

export default __exports__